module.exports = __webpack_public_path__ + "media/images/client-13-e3ce90322ad105645738036a07080779.png";